module.exports = __webpack_public_path__ + "img/837667_DCD4C8_C5BAAC_3C2E22-256px.b414666d.png";